import "./styles.scss";
import { getLocalizedString } from "../../shared/translation";

export const QIAutoMapIndicator = ({
  currentTab,
  mapProvider,
  dataId,
  trackingPoints,
  userHasAdjustedMap,
  resetMapToInitialState,
}) => {
  if (currentTab !== "Map" || mapProvider !== "qiMap" || !dataId || !trackingPoints?.length) {
    return null;
  }

  return (
    <div className="map-mode-indicator">
      <span
        className={`mode-badge ${userHasAdjustedMap ? "mode-badge--manual" : "mode-badge--auto"}`}
        title={
          userHasAdjustedMap
            ? "Manual Mode: Map position controlled by user. Auto-follow disabled."
            : "Auto Mode: Map automatically follows latest vehicle data."
        }
      >
        {userHasAdjustedMap ? (
          <span onClick={resetMapToInitialState}>{getLocalizedString("follow", "Follow")}</span>
        ) : (
          <span>{getLocalizedString("following", "Following")}</span>
        )}
      </span>
    </div>
  );
};
